<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isImmagini="false" :isPrestazioni="true" :isAllegati="false" :btnFirmaVisible="btnFirmaVisible" @updateFirma="onFirmaUpdate">
    <template slot="tab-content-event">
      <gastro-cartella-infermieristica-view-component @update="onUpdateJsonData" :key="gastroCartellaInfermieristicaKey"></gastro-cartella-infermieristica-view-component>
    </template>
  </eventi-view-component>
</template>

<script>
// import axios from "axios";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import GastroCartellaInfermieristicaViewComponent from "../components/GastroCartellaInfermieristicaViewComponent.vue";
export default {
  components: { EventiViewComponent, GastroCartellaInfermieristicaViewComponent },
  mixins: [UtilityMixin, EventiMixin],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      titoloEvento: "CARTELLA INFERMIERISTICA",
      linkback: null,
      linkedit: null,
      jsonData: {},
      pathResource: "/gastroschedainfermieristica",
      tabIndex: 0,
      gastroCartellaInfermieristicaKey: 0,
      btnFirmaVisible: true,
      id: null,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      showModalLoading: false,
      linkPrintData: null,
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
    me.gastroCartellaInfermieristicaKey++;
  },

  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onFirmaUpdate() {
      let me = this;
      me.btnFirmaVisible = false;
      me.gastroCartellaInfermieristicaKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      if (me.jsonData.firma) {
        me.btnFirmaVisible = false;
      } else {
        me.btnFirmaVisible = true;
      }
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>

<style></style>
